<div class="layout-topbar">
  <div class="text-center">
    <a class="layout-topbar-logo" routerLink="">
      <dynamic-logo></dynamic-logo>
    </a>
  </div>

  <button #menubutton class="p-link layout-topbar-button mx-6" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
  </button>

  <!-- <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button> -->

  <div class="w-full flex ml-8 gap-4">
    <ng-container *ngFor="let h of headerService.headerDirectiveList">
      <div *ngIf="h.title" class="text-2xl font-extrabold mt-2">{{ h.title }}</div>
      <div *ngIf="!h.title">
        <ng-container *ngTemplateOutlet="h.templateRef"> </ng-container>
      </div>
    </ng-container>
  </div>

  <div #topbarmenu class="layout-topbar-menu" [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }">
     <button class="p-link layout-topbar-button mx-3" (click)="openSearch()">
      <i class="pi pi-search"></i>
    </button>
    <button class="p-link layout-topbar-button mx-3" (click)="toggleDarkMode()">
      <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
    </button>
    <!-- <button class="p-link layout-topbar-button">
      <i class="pi pi-calendar"></i>
      <span>Calendar</span>
    </button> -->
    <div class="flex items-center gap-2">
      <button class="p-link layout-topbar-button mx-3" (click)="op.toggle($event)">
        <i class="pi pi-user"></i>
      </button>
      <span class="whitespace-nowrap text-lg font-medium inline-block">{{ userFullName }}</span>
    </div>

    <p-overlayPanel #op>
      <div class="flex flex-col gap-2 min-w-[200px] p-2">
        <button pButton class="p-button-text w-full justify-start" (click)="onProfile(); op.toggle($event)">
          <i class="pi pi-user mr-2"></i>
          <span>Mio profilo</span>
        </button>
        <div class="border-t border-gray-200 dark:border-gray-700 my-2"></div>
        <button pButton class="p-button-text w-full justify-start p-button-danger" (click)="onLogout()">
          <i class="pi pi-sign-out mr-2"></i>
          <span>Logout</span>
        </button>
      </div>
    </p-overlayPanel>

    <!-- <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
      <i class="pi pi-cog"></i>
      <span>Settings</span>
    </button> -->
  </div>
</div>
